export default class BurgerMenu {
  constructor(breakpoint) {
    this.openerSelector = '.menu-opener';
    this.activeClass = 'menu-active';
    this.container = document.body;
    this.dropSelector = '.menubar';
    this.breakpoint = breakpoint || '1024px';
    this.focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    this.activated = false;
    this.onShow = new CustomEvent('onShow');
    this.onHide = new CustomEvent('onHide');

    this.init();
  }

  init() {
    this.container.API = this;
    this.opener = Array.from(document.querySelectorAll(this.openerSelector));
    this.drop = document.querySelector(this.dropSelector);

    const mediaQuery = window.matchMedia(`(min-width: ${this.breakpoint})`);
    mediaQuery.addEventListener('change', handleChange.bind(this));

    // Initial check
    handleChange.bind(this)(mediaQuery);

    function handleChange(e) {
      if (e.matches) {
        if (this.activated) this.destroy();
      } else {
        if (this.activated) return;
        this.opener.forEach((opener) => {
          opener.setAttribute('aria-haspopup', 'true');
          opener.setAttribute('aria-expanded', 'false');
        });

        this.attachEvents();
      }
    }
  }

  attachEvents() {
    this.activated = true;
    this.outsideClickHandler = this.outsideClick.bind(this);
    this.keyPressHandler = this.keyPress.bind(this);
    this.clickHandler = handleClick.bind(this);

    this.drop.querySelectorAll(this.focusableElements).forEach((item) => {
      item.setAttribute('tabindex', '-1');
    });

    this.opener.forEach((opener) => {
      opener.addEventListener('click', this.clickHandler);
    });

    function handleClick(e) {
      e.preventDefault();

      if (this.isActive) {
        this.hideMenu();
      } else {
        this.showMenu();
      }
    }
  }

  showMenu() {
    this.container.classList.add(this.activeClass);
    this.isActive = true;
    this.opener.forEach((opener) => {
      opener.setAttribute('aria-expanded', this.isActive);
    });

    this.drop.querySelectorAll(this.focusableElements).forEach((item) => {
      item.removeAttribute('tabindex');
    });

    document.addEventListener('click', this.outsideClickHandler);
    this.container.addEventListener('keydown', this.keyPressHandler);

    // trigger onShow event
    this.container.dispatchEvent(this.onShow);
  }

  hideMenu() {
    this.container.classList.remove(this.activeClass);
    this.isActive = false;
    this.opener.forEach((opener) => {
      opener.setAttribute('aria-expanded', this.isActive);
    });

    document.removeEventListener('click', this.outsideClickHandler);
    this.container.removeEventListener('keydown', this.keyPressHandler);

    this.drop.querySelectorAll(this.focusableElements).forEach((item) => {
      item.setAttribute('tabindex', '-1');
    });

    // trigger onHide event
    this.container.dispatchEvent(this.onHide);
  }

  outsideClick(e) {
    // Проверяем, был ли клик по кнопке меню или внутри меню
    const clickedOpener = this.opener.some((opener) => opener.contains(e.target));
    const clickedMenu = this.drop.contains(e.target);

    if (!clickedOpener && !clickedMenu) {
      this.hideMenu();
    }
  }

  keyPress(e) {
    const focusableContent = this.drop.querySelectorAll(this.focusableElements);
    const firstFocusableElement = focusableContent[0];
    const lastFocusableElement = focusableContent[focusableContent.length - 1];
    let isTabPressed = e.key === 'Tab';

    if (e.key === 'Escape') {
      const curFocused = this.drop.querySelector('[aria-expanded="true"]');

      if (curFocused) return;

      this.hideMenu();
      document.removeEventListener('keydown', this.keyPressHandler);
    }

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      if (document.activeElement === firstFocusableElement) {
        this.opener[0].focus();
        e.preventDefault();
      } else if (document.activeElement === this.opener[0]) {
        lastFocusableElement.focus();
        e.preventDefault();
      }
    } else {
      if (document.activeElement === lastFocusableElement) {
        this.opener[0].focus();
        e.preventDefault();
      }
    }
  }

  destroy() {
    this.isActive = '';
    this.container.classList.remove(this.activeClass);
    this.opener.forEach((opener) => {
      opener.removeAttribute('aria-haspopup');
      opener.removeAttribute('aria-expanded');
      opener.removeEventListener('click', this.clickHandler);
    });
    document.removeEventListener('click', this.outsideClickHandler);
    this.container.removeEventListener('keyup', this.keyPressHandler);
    this.drop.removeAttribute('z-index');
    this.drop.querySelectorAll(this.focusableElements).forEach((item) => {
      item.removeAttribute('tabindex');
    });
    this.container.API = '';
    this.activated = false;
  }
}
